import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
export var api__getCitiesDropDown = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var _res$data;
    var res, cities;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return fetcher().get("/site/cities");
        case 1:
          res = _context.v;
          cities = res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data;
          return _context.a(2, cities || {});
      }
    }, _callee);
  }));
  return function api__getCitiesDropDown() {
    return _ref.apply(this, arguments);
  };
}();